import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['spinner']

  declare readonly spinnerTarget: HTMLElement

  connect (): void {
    this.hideSpinner()

    window.addEventListener('pageshow', this.handlePageShow)
  }

  disconnect (): void {
    window.removeEventListener('pageshow', this.handlePageShow)
  }

  showSpinner (): void {
    this.spinnerTarget.classList.remove('hidden')
  }

  hideSpinner (): void {
    this.spinnerTarget.classList.add('hidden')
  }

  handlePageShow = (_event: PageTransitionEvent): void => {
    this.hideSpinner()
  }
}
